export const PBJ_JOB_TITLE_CODES = [
  { code: 1, title: 'Administrator' },
  { code: 2, title: 'Medical Director' },
  { code: 3, title: 'Physicians' },
  { code: 4, title: 'Physician Aids' },
  { code: 5, title: 'Director of Nursing' },
  { code: 6, title: 'Administrative RN' },
  { code: 7, title: 'RN' },
  { code: 8, title: 'Administrative LVN' },
  { code: 9, title: 'LVN' },
  { code: 10, title: 'CNA' },
  { code: 11, title: 'Nurse Aid in Training' },
  { code: 12, title: 'Medication Aid/Tech' },
  { code: 13, title: 'RN Practitioner' },
  { code: 14, title: 'Clinical RN' },
  { code: 15, title: 'Pharmacist' },
  { code: 16, title: 'Dietitian' },
  { code: 17, title: 'Feeding Assistant' },
  { code: 18, title: 'Occupational Therapy (OT)' },
  { code: 19, title: 'OT Assistant' },
  { code: 20, title: 'OT Aid' },
  { code: 21, title: 'Physical Therapy (PT)' },
  { code: 22, title: 'PT Assistant' },
  { code: 23, title: 'PT Aid' },
  { code: 24, title: 'Respiratory Therapist (RT)' },
  { code: 25, title: 'RT Technician' },
  { code: 26, title: 'Speech/Language Pathology (ST)' },
  { code: 27, title: 'Therapeutic Rec Specialist' },
  { code: 28, title: 'Qualified Activities Person' },
  { code: 29, title: 'Activity Aid' },
  { code: 30, title: 'Qualified Social Worker' },
  { code: 31, title: 'Social Worker' },
  { code: 32, title: 'Dentist' },
  { code: 33, title: 'Podiatrist' },
  { code: 34, title: 'Mental Health Service Worker' },
  { code: 35, title: 'Vocational Service Worker' },
  { code: 36, title: 'Clinical Lab Services' },
  { code: 37, title: 'X-Ray Services' },
  { code: 38, title: 'Blood Services' },
  { code: 39, title: 'Housekeeping' },
  { code: 40, title: 'Other (Everyone Else)' }
]

export const PBJ_PAY_TYPE_CODES = [
  {
    code: 1,
    title: 'Exempt',
    description: "Applied if the Payment Type is 'Employee' and the Pay Method is 'Salary'."
  },
  {
    code: 2,
    title: 'Non-Exempt',
    description: "Applied if the Payment Type is 'Employee' and the Pay Method is any other than 'Salary'."
  },
  {
    code: 3,
    title: 'Contract',
    description: "Applied if the Payment Type is 'Contractor'."
  }
]
